import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Input, FormGroup, Card, CardBody, CardHeader, Collapse, Tooltip } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import uuid from 'react-uuid';
import Select, { components } from 'react-select';

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const WinterGrazingItemSpecView = ({ handleMultiSelectChange,itemPopupItemFeild, itemPopupItemSepcQ, handleItemSepcValueChange, itemPopupHeader, handleItemPopupHeaderChange }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    useEffect(() => {

    }, [])

    return (
        <>
            {itemPopupHeader.id != 0 &&
                <>
                    <Card>
                        <CardHeader className="card-header-click" onClick={toggle}>
                            <Row>
                                <Col sm="12">
                                    <h6>Paddock wintering plan</h6>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row >
                                <Col sm="6">
                                    <FormGroup className=''>
                                        <Label>Mob name and size</Label>
                                        <Input type="textbox" name="MobNameAndsize" id="MobNameAndsize" value={itemPopupItemSepcQ.MobNameAndsize} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup className=''>
                                        <Label>Diet following transition</Label>
                                        <Input type="textbox" name="DietFollowingTransition" id="DietFollowingTransition" value={itemPopupItemSepcQ.DietFollowingTransition} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>

                            </Row>
                            <Row>
                                <Col sm="12">
                                    <label style={{ fontSize: "16px" }}><b>Executing the grazing plan</b></label>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Stock transition plan</Label>
                                        <Input type="textarea" name="StockTransitionPlan" id="StockTransitionPlan" value={itemPopupItemSepcQ.StockTransitionPlan} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Mud reduction</Label>
                                    <Input type="textarea" name="MudReduction" id="MudReduction" value={itemPopupItemSepcQ.MudReduction} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Animal health and welfare monitoring</Label>
                                    <Input type="textarea" name="AnimalHealthAndWelfareMonitoring" id="AnimalHealthAndWelfareMonitoring" value={itemPopupItemSepcQ.AnimalHealthAndWelfareMonitoring} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Risk reduction of of calving/lambing on crop</Label>
                                    <Input type="textarea" name="RiskReductionOfCalvingLambingOnCrop" id="RiskReductionOfCalvingLambingOnCrop" value={itemPopupItemSepcQ.RiskReductionOfCalvingLambingOnCrop} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Ensuring stock are well fed</Label>
                                    <Input type="textarea" name="EnsuringStockAreWellFed" id="EnsuringStockAreWellFed" value={itemPopupItemSepcQ.EnsuringStockAreWellFed} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Ensuring everyone understands the plan</Label>
                                        <Input type="textarea" name="EnsuringEveryoneUnderstandsThePlan" id="EnsuringEveryoneUnderstandsThePlan" value={itemPopupItemSepcQ.EnsuringEveryoneUnderstandsThePlan} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <label style={{ fontSize: "16px" }}><b>Wet weather and poor soil conditions</b></label>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Wet weather plan implementation</Label>
                                        <Input type="textarea" name="WetWeatherPlanImplementation" id="WetWeatherPlanImplementation" value={itemPopupItemSepcQ.WetWeatherPlanImplementation} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Wet weather poor soil conditions</Label>
                                        <Input type="textarea" name="WetWeatherPoorSoilConditions" id="WetWeatherPoorSoilConditions" value={itemPopupItemSepcQ.WetWeatherPoorSoilConditions} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <label style={{ fontSize: "16px" }}><b>Adverse event plan</b></label>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Implementing an adverse plan</Label>
                                        <Input type="textarea" name="ImplementingAnAdversePlan" id="ImplementingAnAdversePlan" value={itemPopupItemSepcQ.ImplementingAnAdversePlan} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Adverse event plan detail</Label>
                                        <Input type="textarea" name="AdverseEventPlanDetail" id="AdverseEventPlanDetail" value={itemPopupItemSepcQ.AdverseEventPlanDetail} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <label style={{ fontSize: "16px" }}><b>Documentation and review</b></label>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Good management practice evidence</Label>
                                        <Input type="textarea" name="GoodManagementPracticeEvidence" id="GoodManagementPracticeEvidence" value={itemPopupItemSepcQ.GoodManagementPracticeEvidence} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup className=''>
                                        <Label>Reviewing the wintering plan</Label>
                                        <Input type="textarea" name="ReviewingTheWinteringPlan" id="ReviewingTheWinteringPlan" value={itemPopupItemSepcQ.ReviewingTheWinteringPlan} onChange={handleItemSepcValueChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <br />
                </>
            }
            
        </>
    )

}
export default WinterGrazingItemSpecView